import { type SxProps, type Theme } from '@mui/system';

export const circleLineSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  '& .circle': {
    width: '37px',
    height: '37px',
    borderRadius: '50%',
    backgroundColor: '#707070',
    color: '#FFFFFF',
    fontSize: '18px',
    lineHeight: '37px',
    textAlign: 'center',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&.circle-selected': {
      backgroundColor: '#006EC2',
    },
    '&:hover': {
      cursor: 'pointer',
      boxShadow:
        '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
  },
  '& .line': {
    width: '40px',
    height: '2px',
    backgroundColor: '#707070',
    '&.line-selected': {
      backgroundColor: '#006EC2',
    },
  },
};
